import React from "react";
import styles from "./NFTlist.module.sass";
import cn from "classnames";
import redeem from "../../../i11/Redeem";
import { useUser } from "../../../context";

const getStatus = (item) => {
	if (item.experience) {
		return item.experience.status;
	} else return "NOT_REQUEST";
};

const Row = ({ open, item }) => {
	const { locale } = useUser();
	return (
		<div
			onClick={() => {
				open(item);
			}}
			className={styles.row}
		>
			<div className={styles.col}>#{item.tokenId}</div>
			<div className={styles.col}>{item.owner?.userName}</div>
			<div className={styles.mail}>{item.owner?.email}</div>
			<div className={styles.col}>
				{item.isOnSale ? "For sale" : "Not listed"}
			</div>
			<div className={styles.col}>
				{item.price} {item.currency}
			</div>
			{item.tokenType === "EXPERIENCE_TOKEN" ? (
				<div className={styles.col}>
					<div style={{ display: "flex" }}>
						<div className={cn(styles[getStatus(item)], styles.status)}>
							{redeem[locale].expStat[getStatus(item)]}
						</div>
					</div>
				</div>
			) : null}
		</div>
	);
};

export default Row;
